import { apiClient } from './apiClient';

/** One asset's outcome from POST /google-ads/image-assets/sync. */
export interface ImageAssetSyncResultItem {
  asset_id: string;
  // success | reused | dry_run | not_found | download_failed | rejected
  status: string;
  asset_resource_name?: string | null;
  eligible_field_types?: string[] | null;
  error?: string;
}

export interface ImageAssetSyncResponse {
  customer_id: string;
  count: number;
  summary: { uploaded: number; dry_run: number; failed: number };
  results: ImageAssetSyncResultItem[];
}

class GoogleAdsImageAssetsService {
  /**
   * Push selected client-image-asset ids to the tenant's Google Ads account as
   * reusable ImageAssets (PMax #11). Idempotent server-side. `dryRun` (default
   * true) validates + logs without a live write.
   */
  async sync(
    tenantId: string,
    assetIds: string[],
    dryRun = true,
  ): Promise<ImageAssetSyncResponse> {
    const { data } = await apiClient.post<ImageAssetSyncResponse>(
      `/google-ads/image-assets/sync?tenant_id=${encodeURIComponent(tenantId)}`,
      { asset_ids: assetIds, dry_run: dryRun },
    );
    return data;
  }
}

export const googleAdsImageAssetsService = new GoogleAdsImageAssetsService();
